// https://webmaniabr.com/docs/rest-api-cep-ibge/
// Cadastrado na API com o e-mail: celsogarcia@webnets.com
// senha: Y9eZNoGw
// X-Token: 8b41fd9b-6d01-4c1c-a6d5-d0c71b4b3792
// APP_KEY = 'STnG2jZdtIchNEJpzcrci7EZqxlNVqo8';
// APP_SECRET = 'uSMr391H37d1uAHxIUq1kF1EpHzJypCbWl5jkFDukczMBGHq';

const apiCep = (busca) => fetch(`https://viacep.com.br/ws/${busca}/json/`)
  .then((resp) => resp.json())
  .then((data) => data);

export default apiCep;
